<template>
    <div class="d-flex flex-wrap my-2">
        <span class="mr-2 mb-1">Insert tag:</span>
        <v-btn
            v-for="tag in tags"
            :key="tag.value"
            x-small
            outlined
            color="primary"
            class="mr-2 mb-1"
            @click="insertTag(tag.value)">
            {{ tag.label }}
        </v-btn>
    </div>
</template>

<script>
export default {
    name: 'TagButtons',
    props: {
        value: {
            type: String,
            default: ''
        }
    },
    data() {
        return {
            tags: [
                { label: 'Client Name', value: '{clientName}' },
                { label: 'Recipient First Name', value: '{recipientFirstName}' },
                { label: 'Recipient Last Name', value: '{recipientLastName}' },
                { label: 'Recipient Position', value: '{recipientPosition}' },
                { label: 'Site Name', value: '{siteName}' },
                { label: 'Site Address', value: '{siteAddress}' },
                { label: 'Scope of Works', value: '{scopeOfWorks}' },
            ]
        };
    },
    methods: {
        insertTag(tag) {
            this.$emit('insert-tag', tag);
        }
    }
};
</script>
